"use cleint";

import { NewOptionAPIReturn } from "@/@types/question-option";
import { QuestionOptionSchemaType } from "@/lib/zod/types";
import api from "@/services/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

export function useCreateOption() {
  const queryClient = useQueryClient();
  const abortController = useRef<AbortController | null>(null);

  const mutation = useMutation({
    mutationFn: async (option: QuestionOptionSchemaType) => {
      abortController.current = new AbortController();

      const { data } = await api.post<NewOptionAPIReturn>(
        "/questions/options",
        option
      );

      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["/assessment-by-id"],
      });
    },
  });

  return { ...mutation, abort: () => abortController.current?.abort() };
}
